import React from "react";
import PropTypes from "prop-types";
import SvgIcon from "@mui/material/SvgIcon";

export default function RoundIndicatorIcon(props) {
  return (
    <SvgIcon {...props}>
      <circle cx="12" cy="8" r="4"/>
    </SvgIcon>
  );
}

RoundIndicatorIcon.propTypes = {
  color: PropTypes.string
};